import React from 'react';
import PropTypes from 'prop-types';

const DataValue = ({ value, uOM, moreInfo, className = '' }) => (
  <span className={'value-container ' + className}>{value} {uOM}<span className='more-info'>{moreInfo}</span></span>
);

DataValue.propTypes = {
  value: PropTypes.string,
  uOM: PropTypes.string,
  moreInfo: PropTypes.string,
  className: PropTypes.string
};

export default DataValue;
